export default __webpack_public_path__ + "static/media/bg.e8c07452.webp";